/* Katz Tires · pre-lander · eventos para GTM / GA4 · v0.1 */
(function () {
  window.dataLayer = window.dataLayer || [];
  function push(ev, extra) { window.dataLayer.push(Object.assign({ event: ev, kz_page: location.pathname }, extra || {})); }
  document.addEventListener('DOMContentLoaded', function () {
    push('kz_prelander_view');
    document.querySelectorAll('[data-kz-cta]').forEach(function (el) {
      el.addEventListener('click', function () { push('kz_cta_click', { kz_cta: el.getAttribute('data-kz-cta') }); });
    });
    var finder = document.querySelector('[data-kz-finder]');
    if (finder && 'IntersectionObserver' in window) {
      var seen = false;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && !seen) { seen = true; push('kz_finder_view'); } });
      }, { threshold: 0.4 }).observe(finder);
      // el vehículo lo elige el widget de Convermax: registramos el clic en su botón de búsqueda
      finder.addEventListener('click', function (e) {
        var b = e.target.closest('button, .cm_button');
        if (b) push('kz_finder_submit', { kz_finder_tab: (finder.querySelector('.cm_tab-label.active, .cm_tab-label[aria-selected="true"]') || {}).textContent || '' });
      });
    }
    // desplazamiento suave a #kz-finder
    document.querySelectorAll('a[href="#kz-finder"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById('kz-finder');
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  });
})();

/* Selector propio a pantalla completa: Tires/Wheels → ZIP (sucursal más cercana) → (How do you drive?, solo gomas) → Year → Make (logos) → Model → Trim, con datos de Convermax */
(function () {
  var modal = document.querySelector('[data-kz-modal]');
  if (!modal) return;
  var api = modal.getAttribute('data-api').replace(/\/$/, ''), results = modal.getAttribute('data-results') || '/pages/search';
  var fields = ['Year', 'Make', 'Model', 'Submodel'], steps = ['type', 'drive'].concat(fields);
  var chosen = { type: 'Tires' }, current = 0, cache = {};
  // "How do you drive?": solo para gomas. Cada opción apunta a una colección que Tarek ya tiene armada (all season, all terrain, etc.).
  var drives = (modal.getAttribute('data-drives') || '').split(/\n+/).map(function (l) { var p = l.split('|'); return p.length > 1 ? { label: p[0].trim(), handle: p[1].trim(), note: (p[2] || '').trim() } : null; }).filter(Boolean);
  // Código postal → sucursal más cercana (19 locales de Katz, con lat/lng en el setting "stores"; el ZIP se geolocaliza con zippopotam.us, gratis y sin clave)
  var stores = (modal.getAttribute('data-stores') || '').split(/\n+/).map(function (l) { var p = l.split('|').map(function (x) { return x.trim(); }); return p.length >= 5 ? { name: p[0], address: p[1], phone: p[2], lat: +p[3], lng: +p[4], url: p[5] || '' } : null; }).filter(function (x) { return x && !isNaN(x.lat); });
  var zipStep = !!(stores.length && modal.querySelector('[data-step="zip"]'));
  function rebuildSteps() { steps = ['type'].concat(zipStep ? ['zip'] : []).concat(chosen.type === 'Tires' && drives.length ? ['drive'] : []).concat(fields); }
  function afterZip() { if (steps.indexOf('drive') > -1) show(steps.indexOf('drive')); else load('Year'); }
  function confetti() {
    if (modal.querySelector('.kz-confetti')) return;
    var box = document.createElement('div'); box.className = 'kz-confetti'; var colors = ['#cc3333', '#1e8e3e', '#f5a623', '#ffffff', '#111111'];
    for (var i = 0; i < 90; i++) { var c = document.createElement('i'); c.style.left = Math.random() * 100 + 'vw'; c.style.background = colors[i % colors.length]; c.style.animationDelay = Math.random() * .5 + 's'; c.style.animationDuration = (1.3 + Math.random()) + 's'; c.style.transform = 'rotate(' + Math.random() * 360 + 'deg)'; box.appendChild(c); }
    modal.appendChild(box); setTimeout(function () { box.remove(); }, 2600);
  }
  function miles(a, b) { var R = 3958.8, dLat = (b.lat - a.lat) * Math.PI / 180, dLng = (b.lng - a.lng) * Math.PI / 180, x = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * Math.PI / 180) * Math.cos(b.lat * Math.PI / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2); return 2 * R * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x)); }
  function nearest(pt) { var best = null; stores.forEach(function (s) { var d = miles(pt, s); if (!best || d < best.d) best = { s: s, d: d }; }); return best; }
  function storeCard(best, box) {
    var s = best.s, maps = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(s.address);
    box.innerHTML = '<div class="kz-store"><span class="kz-store-tag">Your closest Katz Tires · ' + Math.round(best.d) + ' mi away</span><strong>Katz Tires – ' + s.name + '</strong><span>' + s.address + '</span><span><a href="tel:' + s.phone.replace(/\D/g, '') + '">' + s.phone + '</a> · <a href="' + maps + '" target="_blank" rel="noopener">Directions</a>' + (s.url ? ' · <a href="' + s.url + '">Store page</a>' : '') + '</span></div>';
  }
  var $ = function (s) { return modal.querySelector(s); };
  var progress = $('[data-kz-progress]'), bar = $('[data-kz-bar]'), back = $('[data-kz-back]'), status = $('[data-kz-status]'), final = $('[data-kz-final]'), summary = $('[data-kz-summary]'), filter = $('[data-kz-filter]');
  function dl(ev, extra) { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: ev }, extra || {})); }
  function say(t) { status.textContent = t || ''; }
  function open() { modal.hidden = false; document.documentElement.classList.add('kz-noscroll'); dl('kz_finder_open'); show(0); }
  function close() { modal.hidden = true; document.documentElement.classList.remove('kz-noscroll'); }
  function show(i) {
    current = Math.max(0, Math.min(i, steps.length - 1));
    modal.querySelectorAll('.kz-wstep').forEach(function (el) { el.hidden = el.getAttribute('data-step') !== steps[current]; });
    progress.textContent = 'Question ' + (current + 1) + ' of ' + steps.length;
    bar.style.width = ((current + 1) / steps.length * 100) + '%';
    back.hidden = current === 0;
    if (steps[current] === 'Make' && filter) { filter.value = ''; applyFilter(); setTimeout(function () { filter.focus(); }, 50); }
    if (steps[current] === 'Submodel') { final.hidden = !chosen.Submodel; }
    modal.querySelector('.kz-modal-body').scrollTop = 0;
    dl('kz_finder_step', { kz_step: steps[current] });
  }
  function query(want) {
    var q = ['pagesize=0'], n = 0;
    fields.forEach(function (f) { if (f === want || !chosen[f]) return; q.push('facet.' + n + '.field=' + f + '&facet.' + n + '.selection=' + encodeURIComponent(chosen[f])); n++; });
    q.push('facet.' + n + '.field=' + want);
    return api + '/search.json?' + q.join('&');
  }
  function fetchValues(want) {
    var url = query(want);
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url).then(function (r) { return r.json(); }).then(function (d) {
      var f = (d.Facets || []).filter(function (x) { return x.FieldName === want; })[0];
      var vals = ((f && f.Values) || []).map(function (v) { return { value: v.Value, img: v.ImageUrl || '' }; });
      cache[url] = vals; return vals;
    });
  }
  function render(want, vals) {
    var box = $('[data-kz-options="' + want + '"]'); box.innerHTML = '';
    vals.forEach(function (v) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('data-value', v.value);
      b.className = want === 'Make' ? 'kz-logo-tile' : 'kz-chip';
      if (want === 'Make' && v.img) { var im = document.createElement('img'); im.src = v.img; im.alt = ''; im.loading = 'lazy'; im.onerror = function () { im.remove(); b.classList.add('kz-logo-tile--text'); }; b.appendChild(im); }
      var sp = document.createElement('span'); sp.textContent = v.value; b.appendChild(sp);
      if (chosen[want] === v.value) b.classList.add('is-selected');
      b.addEventListener('click', function () { pick(want, v.value); });
      box.appendChild(b);
    });
  }
  function clearFrom(f) { fields.slice(fields.indexOf(f)).forEach(function (x) { delete chosen[x]; }); final.hidden = true; }
  function pick(field, value) {
    clearFrom(field); chosen[field] = value;
    var box = $('[data-kz-options="' + field + '"]'); box.querySelectorAll('.is-selected').forEach(function (e) { e.classList.remove('is-selected'); });
    var el = box.querySelector('[data-value="' + value.replace(/"/g, '\\"') + '"]'); if (el) el.classList.add('is-selected');
    var next = fields[fields.indexOf(field) + 1];
    if (!next) { confetti(); summary.textContent = (chosen.driveLabel ? chosen.driveLabel + ' tires' : chosen.type) + ' for a ' + chosen.Year + ' ' + chosen.Make + ' ' + chosen.Model + ' ' + chosen.Submodel + (chosen.store ? ' · pickup & install at Katz Tires ' + chosen.store + ' (' + chosen.storeMiles + ' mi)' : ''); final.hidden = false; $('[data-kz-go]').focus(); return; }
    load(next);
  }
  function load(want) {
    say('Loading…');
    fetchValues(want).then(function (vals) {
      say('');
      if (!vals.length) { say('No fitment data for this vehicle yet. Try searching by tire size.'); return; }
      render(want, vals);
      if (vals.length === 1) { pick(want, vals[0].value); if (want !== 'Submodel') return; }
      show(steps.indexOf(want));
    }).catch(function () { say('Could not load options. Please try again.'); });
  }
  function applyFilter() {
    var q = (filter.value || '').toLowerCase();
    modal.querySelectorAll('[data-kz-options="Make"] .kz-logo-tile').forEach(function (t) { t.hidden = q && t.getAttribute('data-value').toLowerCase().indexOf(q) < 0; });
  }
  // paso 1: tarjetas con imagen
  var types = $('[data-kz-types]');
  [['Tires', modal.getAttribute('data-img-tires')], ['Wheels', modal.getAttribute('data-img-wheels')]].forEach(function (t) {
    var b = document.createElement('button'); b.type = 'button'; b.className = 'kz-card-type' + (t[0] === 'Tires' ? ' is-selected' : '');
    b.innerHTML = (t[1] ? '<img src="' + t[1] + '" alt="">' : '') + '<span>' + t[0] + '</span>';
    b.addEventListener('click', function () { chosen.type = t[0]; types.querySelectorAll('.is-selected').forEach(function (e) { e.classList.remove('is-selected'); }); b.classList.add('is-selected'); rebuildSteps(); if (steps[1] === 'zip') { show(1); setTimeout(function () { var z = $('[data-kz-zip]'); if (z && !chosen.zip) z.focus(); }, 60); } else if (steps[1] === 'drive') show(1); else load('Year'); });
    types.appendChild(b);
  });
  // paso ZIP: sucursal más cercana; se puede saltar
  if (zipStep) (function () {
    var input = $('[data-kz-zip]'), result = $('[data-kz-store]'), go = $('[data-kz-zip-go]'), skip = $('[data-kz-zip-skip]'), msg = $('[data-kz-zip-msg]'), t;
    function lookup(zip) {
      msg.textContent = 'Finding your closest Katz…'; result.innerHTML = '';
      fetch('https://api.zippopotam.us/us/' + zip).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (d) {
        var pl = d.places && d.places[0]; if (!pl) throw 0;
        var best = nearest({ lat: +pl.latitude, lng: +pl.longitude });
        chosen.zip = zip; chosen.store = best.s.name; chosen.storeMiles = Math.round(best.d);
        msg.textContent = pl['place name'] + ', ' + pl['state abbreviation'];
        storeCard(best, result); go.hidden = false; go.focus();
        dl('kz_finder_zip', { kz_zip: zip, kz_store: best.s.name, kz_store_miles: chosen.storeMiles });
      }).catch(function () { msg.textContent = "We couldn't find that ZIP code. Check it or skip this step."; go.hidden = true; delete chosen.zip; });
    }
    input.addEventListener('input', function () { var v = input.value.replace(/\D/g, '').slice(0, 5); input.value = v; go.hidden = true; clearTimeout(t); if (v.length === 5) t = setTimeout(function () { lookup(v); }, 250); else { msg.textContent = ''; result.innerHTML = ''; } });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); if (chosen.zip) afterZip(); } });
    go.addEventListener('click', afterZip);
    skip.addEventListener('click', function () { delete chosen.zip; delete chosen.store; dl('kz_finder_zip', { kz_zip: '', kz_store: '' }); afterZip(); });
  })();
  // paso (solo gomas): ¿cómo manejás? → colección de destino
  var driveBox = $('[data-kz-options="drive"]');
  if (driveBox) drives.forEach(function (d) {
    var b = document.createElement('button'); b.type = 'button'; b.className = 'kz-drive'; b.setAttribute('data-value', d.handle);
    b.innerHTML = '<strong>' + d.label + '</strong>' + (d.note ? '<small>' + d.note + '</small>' : '');
    b.addEventListener('click', function () {
      chosen.drive = d.handle; chosen.driveLabel = d.label;
      driveBox.querySelectorAll('.is-selected').forEach(function (e) { e.classList.remove('is-selected'); }); b.classList.add('is-selected');
      dl('kz_finder_drive', { kz_drive: d.label }); load('Year');
    });
    driveBox.appendChild(b);
  });
  rebuildSteps();
  if (filter) filter.addEventListener('input', applyFilter);
  back.addEventListener('click', function () { show(current - 1); });
  $('[data-kz-close]').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  document.querySelectorAll('[data-kz-start], a[href="#kz-finder"]').forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
  $('[data-kz-go]').addEventListener('click', function () {
    if (!chosen.Year || !chosen.Make || !chosen.Model || !chosen.Submodel) return;
    // Convermax rearma la URL con el vehículo y descarta product_type: por eso el destino es la colección (gomas o llantas), que sí acota el catálogo.
    var dest = chosen.type === 'Wheels' ? (modal.getAttribute('data-results-wheels') || results) : (modal.getAttribute('data-results-tires') || results);
    if (chosen.type === 'Tires' && chosen.drive) dest = chosen.drive.charAt(0) === '/' ? chosen.drive : '/collections/' + chosen.drive;
    var parts = [];
    fields.forEach(function (f) { parts.push(f + '/' + encodeURIComponent(chosen[f])); });
    dl('kz_finder_submit', { kz_year: chosen.Year, kz_make: chosen.Make, kz_model: chosen.Model, kz_submodel: chosen.Submodel, kz_type: chosen.type, kz_drive: chosen.driveLabel || '', kz_zip: chosen.zip || '', kz_store: chosen.store || '' });
    try { if (chosen.zip) sessionStorage.setItem('kz_zip', chosen.zip + '|' + chosen.store); } catch (e) {}
    window.location.href = dest + '?' + parts.join('/');
  });
  fetchValues('Year').then(function (v) { render('Year', v); }).catch(function () {});
})();

/* carrusel de reseñas: flechas, puntos y scroll-snap */
(function () {
  var track = document.querySelector('[data-kz-reviews]');
  if (!track) return;
  var cards = track.children, dots = document.querySelector('[data-kz-dots]'), btns = document.querySelectorAll('[data-kz-rev]');
  function perView() { var w = track.clientWidth, c = cards[0] ? cards[0].getBoundingClientRect().width : w; return Math.max(1, Math.round(w / c)); }
  function pages() { return Math.max(1, Math.ceil(cards.length / perView())); }
  function page() { var c = cards[0] ? cards[0].getBoundingClientRect().width + 16 : 1; return Math.round(track.scrollLeft / (c * perView())); }
  function paint() {
    var n = pages(), p = page(); dots.innerHTML = '';
    for (var i = 0; i < n; i++) { var d = document.createElement('i'); if (i === p) d.className = 'is-active'; dots.appendChild(d); }
    btns[0].disabled = p <= 0; btns[1].disabled = p >= n - 1;
  }
  btns.forEach(function (b) { b.addEventListener('click', function () { var c = cards[0].getBoundingClientRect().width + 16; track.scrollBy({ left: Number(b.getAttribute('data-kz-rev')) * c * perView(), behavior: 'smooth' }); }); });
  track.addEventListener('scroll', function () { clearTimeout(track._t); track._t = setTimeout(paint, 80); });
  window.addEventListener('resize', paint); paint();
})();

/* Podium ("Text Us") tapa el botón Continue del selector: en la pre-lander se quita apenas aparece */
(function () {
  function kill() { document.querySelectorAll('[id^="podium"], iframe[src*="podium.com"]').forEach(function (el) { if (el.tagName !== 'SCRIPT') el.remove(); }); }
  kill(); new MutationObserver(kill).observe(document.documentElement, { childList: true, subtree: true });
})();
